import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { MspInProductTrialsOverlayWindowsAppController } from '../controller/MspInProductTrialsOverlayWindowsAppController';
import { MenuState } from '../view/configs/msp-in-product-trials-overlay-window-config';

export class MspInProductTrialsOverlayWindowsAppWebComponent extends BaseWebComponentElement {
  public controller!: MspInProductTrialsOverlayWindowsAppController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MspInProductTrialsOverlayWindowsAppController,
    });
  }

  public setMenuState(menuState: MenuState): void {
    this.controller.view.setMenuState(menuState);
  }

  public onMenuScrollEvent(): void {
    this.controller.view.onMenuScrollEvent();
  }

  public createMenuOverlay(): void {
    this.controller.view.createMenuOverlay();
  }
}
